import { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import Header from "./components/Common/Header/Header";
import mainContext from "./context/mainContext";
import Popup from "./components/Common/Popup";
import { NavBar } from "./components/Common/NavBar";
import dataContext from "./context/dataContext";
import { Signup, Signin, ForgotPassword } from "./pages/Signup";

import Main from "./Main";
import InputClassroomId from "./pages/Signup/InputClassroomId/InputClassroomId";
import userRequests from "./components/api/userRequests";
import SignGoogleUser from "./pages/Signup/SignGoogleUser/SignGoogleUser";
import Loader from "./components/Common/Loader/Loader";
import LoaderFetch from "./components/Common/LoaderFatch/Loader";
import { auth } from "./components/api/firebaseConfig";
import authRequets from "./components/api/authRequests";
import HomeButton from "./components/Common/HomeButton/HomeButton";

export default function Layout() {
  const { header, nav, popup, loader: { loaderFetch } } = useContext(mainContext);
  const { userDetails, setUserDetails } = useContext(dataContext);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  useEffect(() => {
    //Get user data
    const checkLogIn = async () => {
      try {


        setLoading(true);
        await auth.authStateReady()
        console.log("🚀 ~ file: Layout.jsx:31 ~ auth.authStateReady ~ localStorage.access_token:", localStorage.access_token)
        console.log("🚀 ~ file: Layout.jsx:31 ~ auth.authStateReady ~ userDetails:", userDetails)
        console.log("🚀 ~ file: Layout.jsx:29 ~ useEffect ~ (auth.currentUser:", auth.currentUser)
        if (auth.currentUser) {

          let userDetailsInFBStorege = await userRequests.getUserDetails(auth.currentUser?.email);
          console.log("🚀 ~ file: Layout.jsx:40 ~ checkLogIn ~ userDetailsInFBStorege:", userDetailsInFBStorege)

          if (!userDetailsInFBStorege) {//mean the user aklredy auth but not in firestore propably because signinWithRedirect
            userDetailsInFBStorege = await userRequests.createNewUser(auth.currentUser)
            console.log("🚀 ~ file: Layout.jsx:43 ~ checkLogIn ~ userDetailsInFBStorege:", userDetailsInFBStorege)
            localStorage.setItem("access_token", auth.currentUser.accessToken);
          }
          if (!localStorage.access_token) {
            localStorage.setItem("access_token", auth.currentUser.accessToken);

          }


          if (!userDetails && (localStorage.access_token && auth.currentUser)) {

            setUserDetails(userDetailsInFBStorege);
            setLoading(false)
            navigate("/", { replace: true });

          } else {
            setLoading(false)
          }
        } else {

          setLoading(false)
        }
      } catch (error) {
        console.error("🚀 ~ file: Layout.jsx:32 ~ checkLogIn ~ error:", error)
        setLoading(false);
      }
    }
    checkLogIn()
    setTimeout(() => {
      if (window.buildType === "iPhone") {
        let rootEl = document.querySelector("#root");
        if (rootEl) {
          rootEl.style.height = "100dvh";
        }
      }
    }, 200);
  }, []);

  // if user is connected
  if (loading) {
    return (
      <Loader />
    );

  } else {

    if (userDetails)
      return (
        <>
          {window.buildType == "android" ?
            header.isShowHeader && <Header pageName={header.pageName} /> :
            header.isShowHeader ?
              <Header pageName={header.pageName} /> : <HomeButton />

          }

          <Main />
          {loaderFetch && <LoaderFetch />}

          {popup.popup && <Popup>{popup.popup}</Popup>}

          {nav.isShowNav && <NavBar />}
        </>
      );
    // routes without auth
    else
      return (
        <>
          <Routes>
            <Route path="/signup" element={<Signup />} />
            <Route path="/signin-google/:token/:refresh" element={<SignGoogleUser />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="*" element={<Navigate to="/signin" />} />
          </Routes>
          {loaderFetch && <LoaderFetch />}
        </>
      );
  }
}
